import React, { Component } from 'react';
import { Label, Row, Col, Input, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.css';

class TransactionList extends Component {
    constructor(props) {
        super(props);

        const url = this.props.selector != null ? this.props.selector.split('/') : [];
        this.state = {
            investor: (url[0] != null && url[0] !== '') ? decodeURIComponent(url[0]).replace(/\//g, '-') : '',
            fund: (url[1] != null && url[1] !== '') ? decodeURIComponent(url[1]).replace(/\//g, '-') : '',
            startDate: (url[2] != null && url[2] !== '') ? url[2] : '',
            endDate: (url[3] != null && url[3] !== '') ? url[3] : '',
            date: '',
            data: [],
            sheetData: [],
            // clientList: this.props.filterClients(),
            filter: {},
            funds: [],
            investors: [],
            sort: '',
            sortType: 'text',
            sortAsc: true,
            dbField: false,
            headers: [
                { display: 'Investor', accessors: ['companyNameSelect'], filter: true, width: 18 },
                { display: 'Fund', accessors: ['fundSelect'], filter: true, width: 64 },
                { display: 'Transaction Type', accessors: ['type'], width: 20 },
                { display: 'Date', accessors: ['tradeDate'], type: 'date', classNames: 'text-center', width: 12 },
                { display: 'Quantity', accessors: ['quantityNumberOfShares'], type: 'number', classNames: 'text-right', width: 12 },
                { display: 'Price', accessors: ['pricePerUnit'], type: 'currency', classNames: 'text-right', width: 12 },
                { display: 'Amount', accessors: ['amount'], type: 'currency', classNames: 'text-right', width: 12 },
                { display: 'Dividend Rate', accessors: ['ratePerUnit'], type: 'number', classNames: 'text-right', width: 12 },
                { display: 'Date Created', accessors: ['dateCreated'], type: 'datetime', dbField: true, classNames: 'text-center', width: 18 },
                { display: 'Date Updated', accessors: ['dateUpdated'], type: 'datetime', dbField: true, classNames: 'text-center', width: 18 },
            ]
        };
    }

    componentDidMount() {
        this.props.log('TransactionList.js/componentDidMount');
        this.getInvestors(); this.getFunds(); this.onSubmit();
        this.props.passHeaders(this.state.headers, this.callback);
    }

    callback = (headers) => {
        this.props.log('TransactionList.js/callback (headers)', headers);
        this.setState({
            headers: headers
        }, () => this.getCSVdata());
    }

    getFormattedDate = (date) => {
        this.props.info('TransactionList.js/getFormattedDate (date)', date);
        let year = date.getFullYear()//.toString().substr(2, 2);
        let month = (1 + date.getMonth())/*.toString().padStart(2, '0')*/;
        let day = date.getDate()/*.toString().padStart(2, '0')*/;
        return month + '/' + day + '/' + year;
    }

    getFormattedField = (val, type, hide) => {
        this.props.info('TransactionList.js/getFormattedField (val,type, hide)', val, type, hide);
        if (val == null || val === '') return val;
        switch (type) {
            case "date":
                return this.getFormattedDate(new Date(val.substr(0, 4), parseInt(val.substr(5, 2)) - 1, val.substr(8, 2), 0, 0, 0));
            case "datetime":
                return this.getFormattedDate(new Date(val.substr(0, 4), parseInt(val.substr(5, 2)) - 1, val.substr(8, 2))) + ' ' + this.formatAMPM(new Date(val));
            case "number":
                if (hide == null) {
                    return Intl.NumberFormat().format(parseFloat(val));
                } else if (hide) {
                    return val
                }
                break;
            case "currency":
                if (hide == null) {
                    return new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                    }).format(val);
                } else if (hide) {
                    return val
                }
                break;
            default:
                return val;
        }
    }

    formatAMPM = (date) => {
        this.props.info('FormDisplay.js/formatAMPM (date)', date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    getInvestors = () => {
        this.props.log('TransactionList.js/getInvestors');
        fetch('/api/reports/InvestorListings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        investors: results.data.map(item => { return (item.data != null && item.data.companyName != null) ? item.data.companyName : null })
                    });
                } else {
                    this.props.addToast('Unable to get investors.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getFunds = () => {
        this.props.log('TransactionList.js/getFunds');
        fetch('/api/reports/FundListings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        funds: results.data.map(item => { return (item.data != null && item.data.fundName != null) ? item.data.fundName : null })
                    });
                } else {
                    this.props.addToast('Unable to get funds.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onSubmit = () => {
        this.props.log('TransactionList.js/onSubmit');
        fetch('/api/reports/TransactionList', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
            body: JSON.stringify([
                { key: 'startDate', type: 'date', value: this.state.startDate },
                { key: 'endDate', type: 'date', value: this.state.endDate },
                { key: 'investor', type: 'nvarchar', value: this.state.investor },
                { key: 'fund', type: 'nvarchar', value: this.state.fund },
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        data: results.data
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getCSVdata = () => {
        this.props.log('TransactionList.js/getCSVdata');
        if (this.state.data.length === 0 /*|| parseInt(this.state.fund) === 0 || this.state.fund === ''*/) {
            this.props.passData([], '');
        } else {
            const retArr = [
                ['Investor', 'Fund', 'Start Date', 'End Date'],
                [
                    this.state.investor,
                    this.state.fund,
                    this.state.startDate !== '' ? this.getFormattedDate(new Date(this.state.startDate)) : '',
                    this.state.endDate !== '' ? this.getFormattedDate(new Date(this.state.endDate)) : ''
                ],
                []
            ].concat([
                this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                    header.display
                ))
            ]).concat(
                this.state.data.map(row => {
                    let retArray = [];
                    this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).forEach((header, headerIndex) => {
                        retArray[headerIndex] = row.data[header.accessors[0]];
                        switch (headerIndex) {
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                retArray[headerIndex] = this.getFormattedField(row.data[header.accessors[0]], header.type, true);
                                break;
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                if (headerIndex === 4) console.log(row.data[header.accessors[0]], header.type, header.accessors[0], parseFloat(this.getFormattedField(row.data[header.accessors[0]], header.type, true)), this.getFormattedField(row.data[header.accessors[0]], header.type, true))
                                retArray[headerIndex] = !isNaN(parseFloat(this.getFormattedField(row.data[header.accessors[0]], header.type, true))) ? parseFloat(this.getFormattedField(row.data[header.accessors[0]], header.type, true)) : '';
                                break;
                            case 8:
                            case 9:
                                retArray[headerIndex] = this.getFormattedField(row[header.accessors[0]], header.type, true);
                                break;
                            default:
                        }
                    });
                    return retArray;
                })
            );
            const styleArr = [
                [
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } }
                ],
                [
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } }
                ],
                []
            ].concat([
                this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                    { s: { font: { bold: true } } }
                ))
            ]).concat(
                this.state.data.map(row => {
                    let styleArray = [];
                    this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).forEach((header, headerIndex) => {
                        switch (headerIndex) {
                            case 4:
                                // any numeric columns
                                styleArray[headerIndex] = {
                                    // data row
                                    z: '###,##0', s: { font: { color: { rgb: parseFloat(row.data[header.accessors[0]]) < 0 && !isNaN(parseFloat(row.data[header.accessors[0]])) ? 'ff0000' : '000000' } } }
                                };
                                break;
                            case 7:
                                // any numeric columns
                                styleArray[headerIndex] = {
                                    // data row
                                    z: '###,##0.00', s: { font: { color: { rgb: parseFloat(row.data[header.accessors[0]]) < 0 && !isNaN(parseFloat(row.data[header.accessors[0]])) ? 'ff0000' : '000000' } } }
                                };
                                break;
                            case 5:
                            case 6:
                                // any currency columns
                                styleArray[headerIndex] = {
                                    // data row
                                    z: '$###,##0.00', s: { font: { color: { rgb: parseFloat(row.data[header.accessors[0]]) < 0 && !isNaN(parseFloat(row.data[header.accessors[0]])) ? 'ff0000' : '000000' } } }
                                };
                                break;
                            default:
                                // fund and sector columns
                                styleArray[headerIndex] = null
                        }
                    })
                    return styleArray;
                })
            );
            this.props.passData(retArr, "transaction-list", styleArr);
        }
    }

    onChange = (e) => {
        this.props.log('TransactionList.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        let value = '';
        let refresh = true;
        this.setState((prevState) => {
            let sel = prevState;
            sel[e.target.name] = (e.target.value);
            value = ((sel.investor) === '' ? '' : encodeURIComponent(sel.investor)) + '/' + ((sel.fund) === '' ? '' : encodeURIComponent(sel.fund)) + '/' + ((sel.startDate) === '' ? '' : sel.startDate) + '/' + ((sel.endDate) === '' ? '' : sel.endDate);
            if (e.target.name === 'investor' && e.target.value === '0') {
                sel.investor = '';
                value = ((sel.fund !== '') ? '/' + sel.fund : '/');
                value += ((sel.startDate !== '') ? '/' + sel.startDate : '/');
                value += ((sel.endDate !== '') ? '/' + sel.endDate : '/');
            }
            if (e.target.name === 'fund' && e.target.value === '0') {
                sel.fund = '';
                value = ((sel.investor !== '') ? sel.investor + '/' : '/');
                value += ((sel.startDate !== '') ? '/' + sel.startDate : '/');
                value += ((sel.endDate !== '') ? '/' + sel.endDate : '/');
            }
            this.props.changeSelector({ target: { name: '', value: value.replace(/[/]+$/, '') } });
            return sel;
        }, () => {
            if (refresh) {
                this.onSubmit();
            }
            this.getCSVdata();
        });
    }

    onChangeFilter = (e) => {
        this.props.log('TransactionList.js/onChangeFilter (e)', e.target.name, e.target.value);
        e.persist();
        this.setState((prevState) => {
            let sel = prevState;
            sel.filter[e.target.name] = e.target.value;
            return sel;
        })
    }

    render() {
        this.props.info('TransactionList.js/render');
        return (
            <>
                <Row className="mb-4 noPrint">
                    <Col md={3} className="px-2">
                        <Label className='w-100'>Investor
                            <Input type="select" className="companySelect w-100" name="investor" value={this.props.replaceSpecialChars(this.props.isFieldNull(this.state.investor).replace(/\//g, '-'))} onChange={this.onChange}>
                                <option value="0">Show All</option>
                                {this.state.investors.map(investor => (
                                    <option key={investor} value={this.props.replaceSpecialChars(this.props.isFieldNull(investor).replace(/\//g, '-'))}>{investor}</option>
                                ))}
                            </Input>
                        </Label>
                    </Col>
                    <Col md={3} className="px-2">
                        <Label className='w-100'>Fund
                            <Input type="select" className="companySelect w-100" name="fund" value={this.props.replaceSpecialChars(this.props.isFieldNull(this.state.fund).replace(/\//g, '-'))} onChange={this.onChange}>
                                <option value="0">Show All</option>
                                {this.state.funds.map(fund => (
                                    <option key={fund} value={this.props.replaceSpecialChars(this.props.isFieldNull(fund).replace(/\//g, '-'))}>{fund}</option>
                                ))}
                            </Input>
                        </Label>
                    </Col>
                    <Col md={3} className="px-2">
                        <Label className='w-100' >Start Date
                            <Input type="date" name="startDate" value={this.props.isFieldNull(this.state.startDate)} onChange={this.onChange} />
                        </Label>
                    </Col>
                    <Col md={3} className="px-2">
                        <Label className='w-100' >End Date
                            <Input type="date" name="endDate" value={this.props.isFieldNull(this.state.endDate)} onChange={this.onChange} />
                        </Label>
                    </Col>
                </Row>
                {this.state.data.length > 0 ?
                    <Table>
                        <thead>
                            <tr>
                                {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                    <th className={'pointer ' + header.classNames}
                                        onClick={() => this.setState(this.props.setSort(header.accessors[0], header.type, this.state.sort, this.state.sortAsc, header.dbField))}
                                        key={headerIndex}>
                                        {header.display}
                                        {header.accessors[0] === this.state.sort ? <span className="sortChevron">
                                            <FontAwesomeIcon icon={this.state.sortAsc ? faChevronUp : faChevronDown} />
                                        </span> : null}
                                    </th>
                                ))}
                            </tr>
                            <tr>
                                {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                    <th key={headerIndex}>
                                        {header.filter ? <Input
                                            type="text"
                                            name={header.accessors[0]}
                                            placeholder={"Filter " + header.display}
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={this.onChangeFilter}
                                            value={header.accessors[0] != null && this.state.filter[header.accessors[0]] != null ? this.state.filter[header.accessors[0]] : ''}
                                        /> : null}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.orderEntries(this.state.data, { uniqueId: this.state.sort, asc: this.state.sortAsc, type: this.state.sortType }, this.state.dbField).filter(entry => {
                                let temp = true;
                                Object.keys(this.state.filter).forEach(field => {
                                    if ((entry.data[field] != null && this.state.filter[field] != null &&
                                        (entry.data[field].toUpperCase().indexOf(this.state.filter[field].toUpperCase()) === -1)) ||
                                        ((this.state.filter[field] != null && this.state.filter[field] !== '') && entry.data[field] == null)) temp = false;
                                })
                                return temp;
                            }).map(row => (
                                <tr key={row.formEntryId}>
                                    {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                        <td className={(header.dbField ? "dbField" : "") + " " + header.classNames} key={headerIndex}>{header.dbField ?
                                            this.getFormattedField(row[header.accessors[0]], header.type)
                                            : this.getFormattedField(row.data[header.accessors[0]], header.type)}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    : <>No results</>}
            </>
        );

    }
}

export default TransactionList;
